import React, { useRef, useEffect, useState } from "react";
import Hls from "hls.js";
import { PlayFill, PauseFill } from "react-bootstrap-icons";
const IVSPlayback = ({ playBackUrl }) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(true);

  const togglePlay = () => {
    const video = videoRef.current;
    if (!video) return;

    if (video.paused) {
      video.play();
      setIsPlaying(true);
    } else {
      video.pause();
      setIsPlaying(false);
    }
  };
  useEffect(() => {
    if (!playBackUrl) return;

    const video = videoRef.current;

    if (video.canPlayType("application/vnd.apple.mpegurl")) {
      // Safari supports HLS natively
      video.src = playBackUrl;
    } else if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource(playBackUrl);
      hls.attachMedia(video);
      return () => {
        hls.destroy();
      };
    } else {
      console.error("HLS not supported in this browser");
    }
  }, [playBackUrl]);

  return (
    videoRef !== null && (
      <div className="position-relative w-full max-w-md d-flex justify-content-center">
        <video
          ref={videoRef}
          autoPlay
          // muted
          playsInline
          className="img-fluid object-fit-cover rounded  "
          style={{ maxWidth: 360, width: "100%", aspectRatio: 1.3 / 1 }}
        />
        <button
          onClick={togglePlay}
          className="position-absolute top-50 start-50 translate-middle btn btn-dark rounded-circle d-flex align-items-center justify-content-center"
          style={{ width: "60px", height: "60px", opacity: 0.8 }}
        >
          {isPlaying ? <PauseFill size={32} /> : <PlayFill size={32} />}
        </button>
      </div>
    )
  );
};

export default IVSPlayback;
